// @flow
import * as React from 'react';

import BrightnessPicker from '~/components/widgets/flipper/brightness-flipper';
import { noop } from 'lodash/fp';

type Props = {
    isOn: boolean,
    isSaving?: boolean,
    isSmall?: boolean,
    isToggling?: boolean,
    isVariableColour?: boolean,
    rgb?: Uint8ClampedArray,
    toggleLightbulb: noop,
    value?: number,
    valueChanged: noop
};

const StandardBrightnessPicker = ({
    isOn,
    isSaving,
    isToggling,
    toggleLightbulb,
    value,
    valueChanged,
    rgb,
    isSmall,
    isVariableColour
}: Props) => (
    <BrightnessPicker
        isOn={isOn}
        isSaving={isSaving}
        isSmall={isSmall}
        isToggling={isToggling}
        isVariableColour={isVariableColour}
        items={[
            { display: 'Most Dim', value: 5, id: 1 },
            { display: 'Less Dim', value: 10, id: 2 },
            { display: 'Less Dim', value: 20, id: 3 },
            { display: 'Less Dim', value: 30, id: 4 },
            { display: 'Less Dim', value: 40, id: 5 },
            { display: 'Medium', value: 50, id: 6 },
            { display: 'Less Bright', value: 60, id: 7 },
            { display: 'Less Bright', value: 70, id: 8 },
            { display: 'Less Bright', value: 80, id: 9 },
            { display: 'Less Bright', value: 90, id: 10 },
            { display: 'Most Bright', value: 100, id: 11 }
        ]}
        rgb={rgb}
        toggleLightbulb={toggleLightbulb}
        value={value}
        valueChanged={valueChanged}
    />
);

export default StandardBrightnessPicker;



// WEBPACK FOOTER //
// ./src/components/bulbs/standard-brightness-picker.js